/* ============================================================================
   SNAPGOODY — COMMERCE
   Product cards · cart · cart drawer · add-to-cart recommendation pop-up ·
   the layered product designer that opens above it.
   ----------------------------------------------------------------------------
   The cart is held in memory and exposed through one adapter object so the
   Shopify build only has to swap SG.cart.adapter for calls to /cart/add.js,
   /cart/change.js and /cart.js. Nothing else changes.
   ========================================================================== */
(function (global) {
  'use strict';
  var SG = global.SG;
  var $ = SG.$, $$ = SG.$$;

  /* ========================================================== PRODUCT CARD ==*/
  SG.productCard = function (p, opts) {
    opts = opts || {};
    var href = SG.url('product.html?p=' + p.handle);
    var badge = p.badge ? '<span class="card__badge' + (p.luxury ? ' card__badge--ink' : '') + '">' + SG.esc(p.badge) + '</span>' : '';
    var price = '<span class="card__price" data-price="' + p.price + '">' +
      (p.compareAt ? '<s>' + SG.money(p.compareAt) + '</s>' : '') + SG.money(p.price) + '</span>';
    var rank = opts.rank ? '<span class="card__rank">' + (opts.rank < 10 ? '0' : '') + opts.rank + '</span>' : '';
    return '<article class="card zoomable" data-card="' + p.handle + '">' + rank +
      '<a class="card__media" href="' + href + '">' + badge +
        SG.mediaProduct(p.handle, 0, { title: p.title }) +
        (opts.quick === false ? '' :
          '<span class="card__quick">' +
            '<button class="btn" type="button" data-quick="' + p.handle + '">Personalise</button>' +
          '</span>') +
      '</a>' +
      '<a href="' + href + '"><h3 class="card__title">' + SG.esc(p.title) + '</h3></a>' +
      '<div class="card__meta">' + price +
        (p.familyLabel ? '<span class="card__note">' + SG.esc(p.familyLabel) + '</span>' :
          (p.vendor ? '<span class="card__note">' + SG.esc(p.vendor) + '</span>' : '')) +
      '</div>' +
    '</article>';
  };

  SG.bindCards = function (root) {
    $$('[data-quick]', root || document).forEach(function (b) {
      if (b.__bound) return; b.__bound = true;
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        SG.openDesigner(SG.catalog.get(b.getAttribute('data-quick')), {
          onDone: function (pkg, product, opts) {
            SG.cart.add(product, { design: pkg, options: opts });
            SG.closeDesigner();
            SG.recommend.open(product);
          }
        });
      });
    });
  };

  /* ================================================================== CART ==*/
  var cart = {
    items: [],

    /* Swap this object for the Shopify AJAX API in the theme build. -------- */
    adapter: {
      add: function (line) { return Promise.resolve(line); },
      change: function () { return Promise.resolve(); },
      remove: function () { return Promise.resolve(); }
    },

    add: function (product, o) {
      o = o || {};
      var line = SG.catalog.lineFor(product, SG.region, o.options);
      var item = {
        id: SG.uid('line'),
        handle: product.handle,
        title: product.title,
        price: product.price,
        qty: o.qty || 1,
        options: o.options || {},
        design: o.design || null,
        line: line
      };
      cart.items.push(item);
      cart.adapter.add(item);
      cart.sync();
      return item;
    },

    remove: function (id) {
      cart.items = cart.items.filter(function (i) { return i.id !== id; });
      cart.adapter.remove(id);
      cart.sync();
    },

    setQty: function (id, q) {
      cart.items.forEach(function (i) { if (i.id === id) i.qty = Math.max(1, q); });
      cart.adapter.change(id, q);
      cart.sync();
    },

    count: function () { return cart.items.reduce(function (n, i) { return n + i.qty; }, 0); },
    subtotal: function () { return cart.items.reduce(function (n, i) { return n + i.price * i.qty; }, 0); },

    sync: function () {
      var c = $('[data-cart-count]');
      if (c) { c.textContent = cart.count(); c.classList.toggle('is-on', cart.count() > 0); }
      renderDrawer();
      SG.emit('cart:change', cart);
    }
  };
  SG.cart = cart;

  /* A link, or nothing at all. In the Shopify build SG.url() returns '' for a
     destination the store does not have; rendering href="" would look like a
     working link and quietly reload the current page. */
  function linkIf(url, label, style) {
    if (!url) return '';
    return '<p style="' + (style || '') + '"><a class="link" href="' + url + '">' + SG.esc(label) + '</a></p>';
  }

  /* ----------------------------------------------------------- cart drawer --*/
  function ensureDrawer() {
    if ($('[data-drawer]')) return;
    document.body.insertAdjacentHTML('beforeend',
      '<div class="scrim" data-drawer-scrim></div>' +
      '<aside class="drawer" data-drawer aria-label="Shopping bag">' +
        '<div class="drawer__head"><h3>Your bag</h3>' +
          '<button class="icon-btn" type="button" data-drawer-close aria-label="Close">' + SG.icon('close') + '</button>' +
        '</div>' +
        '<div class="drawer__body scroll-y" data-drawer-body></div>' +
        '<div class="drawer__foot" data-drawer-foot></div>' +
      '</aside>');
    $('[data-drawer-scrim]').addEventListener('click', closeDrawer);
    $('[data-drawer-close]').addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }
  function openDrawer() {
    ensureDrawer(); renderDrawer();
    $('[data-drawer]').classList.add('is-open');
    $('[data-drawer-scrim]').classList.add('is-on');
    SG.lockScroll(true);
  }
  function closeDrawer() {
    var d = $('[data-drawer]'); if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    $('[data-drawer-scrim]').classList.remove('is-on');
    SG.lockScroll(false);
  }
  SG.openCart = openDrawer;
  SG.on('cart:open', openDrawer);

  function renderDrawer() {
    var body = $('[data-drawer-body]'), foot = $('[data-drawer-foot]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="drawer__empty">' + SG.icon('bag') +
        '<p>Your bag is empty.</p>' +
        /* Only offer a route out that actually resolves in this store. */
        linkIf(SG.url('fitting-room.html'), 'Open the Fitting Room', 'margin-top:1rem') +
        linkIf(SG.allProductsUrl(), 'Browse everything', 'margin-top:.5rem') + '</div>';
      foot.innerHTML = '';
      return;
    }
    body.innerHTML = cart.items.map(function (i) {
      var opts = Object.keys(i.options || {}).map(function (k) { return i.options[k]; }).join(' · ');
      var thumb = i.design && i.design.preview
        ? '<div class="media"><img src="' + i.design.preview + '" alt=""></div>'
        : SG.mediaProduct(i.handle, 0, { compact: true, title: i.title });
      return '<div class="lineitem">' +
        '<div class="lineitem__media">' + thumb +
          (i.design ? '<span class="lineitem__custom">Personalised</span>' : '') + '</div>' +
        '<div>' +
          '<h4>' + SG.esc(i.title) + '</h4>' +
          '<div class="lineitem__opts">' + SG.esc(opts || '—') + '</div>' +
          '<div class="lineitem__foot">' +
            '<span class="lineitem__qty">' +
              '<button type="button" data-dec="' + i.id + '">−</button><span>' + i.qty + '</span>' +
              '<button type="button" data-inc="' + i.id + '">+</button></span>' +
            '<span class="lineitem__price">' + SG.money(i.price * i.qty) + '</span>' +
          '</div>' +
          '<button class="lineitem__remove" type="button" data-rm="' + i.id + '" style="margin-top:.5rem">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');

    foot.innerHTML =
      '<div class="drawer__row"><span>Subtotal</span><span>' + SG.money(cart.subtotal()) + '</span></div>' +
      '<div class="drawer__row"><span>Delivery</span><span>Calculated at checkout</span></div>' +
      '<div class="drawer__row drawer__row--total"><span>Total</span><span>' + SG.money(cart.subtotal()) + '</span></div>' +
      /* A real link, not a bare button — SG.checkoutUrl() is Shopify's secure
         checkout once the theme is installed. See core.js. */
      '<a class="btn btn--block" href="' + SG.checkoutUrl() + '" data-checkout style="margin-top:1.1rem">Checkout</a>' +
      '<button class="btn btn--ghost btn--block" type="button" data-drawer-continue style="margin-top:.6rem">Continue shopping</button>' +
      '<p style="text-align:center;margin-top:.85rem;font-size:var(--fs-micro);letter-spacing:.08em;color:var(--ink-4)">' +
        'Made to order in ' + SG.esc(SG.regions[SG.region].label) + '</p>';

    $$('[data-inc]', body).forEach(function (b) { b.addEventListener('click', function () { var i = find(b.getAttribute('data-inc')); cart.setQty(i.id, i.qty + 1); }); });
    $$('[data-dec]', body).forEach(function (b) { b.addEventListener('click', function () { var i = find(b.getAttribute('data-dec')); cart.setQty(i.id, i.qty - 1); }); });
    $$('[data-rm]', body).forEach(function (b) { b.addEventListener('click', function () { cart.remove(b.getAttribute('data-rm')); }); });
    var cont = $('[data-drawer-continue]', foot);
    if (cont) cont.addEventListener('click', closeDrawer);

    function find(id) { return cart.items.filter(function (i) { return i.id === id; })[0]; }
  }

  /* ========================================= ADD-TO-CART RECOMMENDATION FLOW ==
     1. Product added  →  pop-up appears with the item and three suggestions.
     2. Customer picks a suggestion  →  the designer opens ABOVE the pop-up,
        the page behind stays visible and dimmed.
     3. Design saved  →  back to the pop-up, item now marked personalised.
     4. Add to bag  →  line added without ever leaving the original page.
     ======================================================================== */
  var rec = {
    el: null,
    context: null,
    staged: {}   // handle -> { pkg, options }
  };

  function ensureRecModal() {
    if (rec.el) return;
    var host = SG.el('div', { class: 'recmodal', 'data-recmodal': '' });
    host.innerHTML =
      '<div class="recmodal__scrim" data-rec-scrim></div>' +
      '<div class="recmodal__panel">' +
        '<div class="recmodal__head">' +
          '<span class="recmodal__tick">' + SG.icon('check') + '</span>' +
          '<div><h3>Added to your bag</h3><p data-rec-sub></p></div>' +
          '<button class="recmodal__close" type="button" data-rec-close aria-label="Close">' + SG.icon('close') + '</button>' +
        '</div>' +
        '<div class="recmodal__added" data-rec-added></div>' +
        '<div class="recmodal__body scroll-y">' +
          '<span class="eyebrow">Made to go with it</span>' +
          '<div class="recgrid" data-rec-grid></div>' +
        '</div>' +
        '<div class="recmodal__foot">' +
          '<span class="recmodal__total">Bag subtotal <strong data-rec-total></strong></span>' +
          '<span class="recmodal__actions">' +
            '<button class="btn btn--ghost btn--sm" type="button" data-rec-continue>Keep shopping</button>' +
            '<button class="btn btn--sm" type="button" data-rec-bag>View bag</button>' +
          '</span>' +
        '</div>' +
      '</div>';
    document.body.appendChild(host);
    rec.el = host;

    $('[data-rec-scrim]', host).addEventListener('click', closeRec);
    $('[data-rec-close]', host).addEventListener('click', closeRec);
    $('[data-rec-continue]', host).addEventListener('click', closeRec);
    $('[data-rec-bag]', host).addEventListener('click', function () { closeRec(); openDrawer(); });
  }

  function closeRec() {
    if (!rec.el) return;
    rec.el.classList.remove('is-open');
    SG.lockScroll(false);
  }

  rec.open = function (product, item) {
    ensureRecModal();
    rec.context = { product: product, item: item };
    rec.staged = {};
    var host = rec.el;

    $('[data-rec-sub]', host).textContent = product.title + ' is ready to be made.';
    $('[data-rec-added]', host).innerHTML =
      (item && item.design && item.design.preview
        ? '<div class="media"><img src="' + item.design.preview + '" alt=""></div>'
        : SG.mediaProduct(product.handle, 0, { compact: true, title: product.title })) +
      '<div><strong>' + SG.esc(product.title) + '</strong>' +
        '<span>' + (item && item.design ? 'Personalised · ' : '') +
        Object.keys((item && item.options) || {}).map(function (k) { return item.options[k]; }).join(' · ') + '</span></div>' +
      '<span class="price">' + SG.money(product.price) + '</span>';

    paintRecGrid(SG.catalog.recommend(product.handle, 3));
    $('[data-rec-total]', host).textContent = SG.money(cart.subtotal());

    host.classList.add('is-open');
    host.classList.remove('is-behind');
    SG.lockScroll(true);
  };

  function paintRecGrid(list) {
    var host = $('[data-rec-grid]', rec.el);
    host.innerHTML = list.map(function (p) {
      var staged = rec.staged[p.handle];
      return '<article class="reccard' + (staged ? ' is-personalised' : '') + '" data-rec="' + p.handle + '">' +
        '<div class="reccard__media">' +
          '<span class="reccard__flag">Personalised</span>' +
          (staged && staged.pkg.preview
            ? '<div class="media"><img src="' + staged.pkg.preview + '" alt=""></div>'
            : SG.mediaProduct(p.handle, 0, { title: p.title })) +
        '</div>' +
        '<div class="reccard__body">' +
          '<h4 class="reccard__name">' + SG.esc(p.title) + '</h4>' +
          '<span class="reccard__price">' + SG.money(p.price) + '</span>' +
          '<span class="reccard__actions">' +
            (staged
              ? '<button class="btn btn--clay" type="button" data-rec-add="' + p.handle + '">Add to bag</button>' +
                '<button class="btn btn--ghost" type="button" data-rec-design="' + p.handle + '">Edit design</button>'
              : '<button class="btn" type="button" data-rec-design="' + p.handle + '">Personalise</button>') +
          '</span>' +
        '</div>' +
      '</article>';
    }).join('');

    $$('[data-rec-design]', host).forEach(function (b) {
      b.addEventListener('click', function () {
        var p = SG.catalog.get(b.getAttribute('data-rec-design'));
        openDesignerOverThis(p);
      });
    });
    $$('[data-rec-add]', host).forEach(function (b) {
      b.addEventListener('click', function () {
        var handle = b.getAttribute('data-rec-add');
        var p = SG.catalog.get(handle);
        var st = rec.staged[handle];
        cart.add(p, { design: st.pkg, options: st.options });
        delete rec.staged[handle];
        paintRecGrid(SG.catalog.recommend(rec.context.product.handle, 3));
        $('[data-rec-total]', rec.el).textContent = SG.money(cart.subtotal());
        SG.toast(p.title + ' added to your bag.', 'check');
      });
    });
  }

  /* The designer opens above the pop-up; the pop-up recedes but stays visible. */
  function openDesignerOverThis(product) {
    rec.el.classList.add('is-behind');
    SG.openDesigner(product, {
      backLabel: 'Back to recommendations',
      doneLabel: 'Save & return',
      design: rec.staged[product.handle] ? rec.staged[product.handle].pkg : null,
      onDone: function (pkg, prod, options) {
        rec.staged[prod.handle] = { pkg: pkg, options: options };
        SG.closeDesigner();
        rec.el.classList.remove('is-behind');
        paintRecGrid(SG.catalog.recommend(rec.context.product.handle, 3));
        SG.toast('Design saved — add it to your bag when you are ready.', 'check');
      },
      onClose: function () { rec.el.classList.remove('is-behind'); }
    });
  }

  SG.recommend = rec;

  /* ===================================================== LAYERED DESIGNER ===*/
  var designer = { el: null, editor: null, opts: null };

  function ensureDesigner() {
    if (designer.el) return;
    var host = SG.el('div', { class: 'layerdesign', 'data-layerdesign': '' });
    host.innerHTML =
      '<div class="layerdesign__scrim" data-ld-scrim></div>' +
      '<div class="layerdesign__panel">' +
        '<div class="layerdesign__head">' +
          '<button class="layerdesign__back" type="button" data-ld-back>' + SG.icon('chevronL') + '<span data-ld-backlabel>Back</span></button>' +
          '<span class="layerdesign__div"></span>' +
          '<span class="layerdesign__title" data-ld-title></span>' +
          '<span class="layerdesign__crumb" data-ld-crumb></span>' +
          '<span class="layerdesign__actions">' +
            '<button class="btn btn--clay btn--sm" type="button" data-ld-save>Save &amp; return</button>' +
            '<button class="icon-btn" type="button" data-ld-close aria-label="Close">' + SG.icon('close') + '</button>' +
          '</span>' +
        '</div>' +
        '<div class="layerdesign__mount" data-ld-mount></div>' +
      '</div>';
    document.body.appendChild(host);
    designer.el = host;
    $('[data-ld-scrim]', host).addEventListener('click', SG.closeDesigner);
    $('[data-ld-close]', host).addEventListener('click', SG.closeDesigner);
    $('[data-ld-back]', host).addEventListener('click', SG.closeDesigner);
    $('[data-ld-save]', host).addEventListener('click', function () {
      if (!designer.editor) return;
      designer.editor.generate().then(function (pkg) {
        if (designer.opts && designer.opts.onDone) designer.opts.onDone(pkg, designer.editor.product, designer.editor.options);
      });
    });
  }

  SG.openDesigner = function (product, opts) {
    opts = opts || {};
    ensureDesigner();
    designer.opts = opts;
    var host = designer.el;
    $('[data-ld-title]', host).textContent = product.title;
    $('[data-ld-crumb]', host).textContent = 'Personalisation studio';
    $('[data-ld-backlabel]', host).textContent = opts.backLabel || 'Back';

    var mount = $('[data-ld-mount]', host);
    if (designer.editor) designer.editor.destroy();
    designer.editor = new SG.Editor(mount, {
      product: product,
      mode: 'overlay',
      design: opts.design || null,
      doneLabel: opts.doneLabel || 'Save design',
      onDone: function (pkg, ed) {
        if (opts.onDone) opts.onDone(pkg, product, ed.options);
      }
    });

    host.classList.add('is-open');
    SG.lockScroll(true);
    requestAnimationFrame(function () { designer.editor.fit(); });
  };

  SG.closeDesigner = function () {
    if (!designer.el) return;
    designer.el.classList.remove('is-open');
    SG.lockScroll(false);
    if (designer.opts && designer.opts.onClose) designer.opts.onClose();
  };

  /* Re-price everything when the market changes. */
  SG.on('region', function () { cart.sync(); });

}(window));
